/**
 * [ File :: G_Common.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/util/G_Common.js
 * @목적 : 중복사용 가능한 계산식 및 함수를 정리하는 클래스 (static위주로 사용)
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

const G_Common = (function () {

	return class {

		// [F]

		/**
		 * [ Function :: getGrid ]
		 *
		 * @DES :: 그리드 좌표값 구하기 함수
		 * @INP :: x[num], y[num]
		 * @OUT :: rtn[arr]
		 * @S.E ::
		 */
		static getGrid(dx, dy, x, y) {
			return [Math.ceil(x / dx), Math.ceil(y / dy)]
		}

		/**
		 * [ Function :: getPixel ]
		 *
		 * @DES :: 캔버스 픽셀값 구하기 함수
		 * @INP :: x[num], y[num]
		 * @OUT :: rtn[arr]
		 * @S.E ::
		 */
		static getPixel(x, y) { /*...*/ }

		/**
		 * [ Function :: calRotate ]
		 *
		 * @DES :: 회전방향 계산하기
		 * @INP :: direction[str], rotate[num]
		 * @OUT :: rotate[num]
		 * @S.E ::
		 */
		static calRotate(dir, rot) {
			switch (dir) {
				case "back" :
					rot += 180;
					break;
				case "left" :
					rot -= 90;
					break;
				case "right" :
					rot += 90;
					break;
			}
			if (rot > 360) rot -= 360;
			if (rot <= 0) rot += 360;
			return rot;
		}
	};
}());

export default G_Common;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/util/G_Common.js